//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.SheetmetalBaseBuilder.js";
import "../Features/Features.SheetMetal.CleanUpUtilityListItemBuilderList.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Features.js";
import "../no/ObjectList.js";
let d=[[[0,"HideOriginal",1,0],[0,"InferThickness",1,0],[0,"MergeCoplanarFaces",1,0],[1,"MultiHeightZoneList",0,"Features.SheetMetal.CleanUpUtilityListItemBuilderList",0],[1,"SelectBaseFace",0,"ScCollector",0],[0,"SliverTol",1,1],[1,"SliverTolerance",0,"Expression",0],[1,"ThicknessTolerance",0,"Expression",0],[1,"ThicknessValue",0,"Expression",0],[0,"Type",1,0],[0,"UseGlobal",1,0]],[[[],"CreateCleanUpUtilityListItemBuilder",{R_:{listBuilder:"Features.SheetMetal.CleanUpUtilityListItemBuilder"}},0,0]],[]];
SPLM.Features.SheetMetal.CleanUpUtilityBuilder = class extends SPLM.Features.SheetMetal.SheetmetalBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.CleanUpUtilityBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.CleanUpUtilityBuilder.CleanupType = Object.freeze({
    "UniformThickness" : "UniformThickness", "MultiThickness" : "MultiThickness"});

export default SPLM;